import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

type Options = {
  enabled?: boolean;
  workspaceSlug?: string;
  onChange?: () => void;
};

/**
 * Live-refresh calendar tasks / trips / attachments for a workspace.
 * Requires migration 268 (tables on supabase_realtime).
 */
export function useCalendarWorkspaceRealtime(options: Options = {}) {
  const { enabled = true, workspaceSlug, onChange } = options;
  const filter = workspaceSlug
    ? `workspace_slug=eq.${workspaceSlug}`
    : undefined;

  usePostgresChangesRealtime({
    enabled: enabled && Boolean(workspaceSlug),
    channelName: `calendar-live:${workspaceSlug ?? 'none'}`,
    portalKind: 'crm',
    debounceMs: 400,
    onChange,
    listens: [
      { schema: 'crm', table: 'calendar_tasks', filter },
      { schema: 'crm', table: 'calendar_trips', filter },
      // Attachments have no workspace_slug — any change may affect open task detail.
      { schema: 'crm', table: 'calendar_task_attachments' },
    ],
  });
}
